import { request } from 'Apiv2/handleRequest';

export const getVideo = async (videoId) => {
  const response = await request(`/admin/library_videos/${videoId}.json`);
  return response.json();
};

export const createVideo = async (videoData) => {
  const response = await request('/admin/library_videos', 'POST', { library_video: videoData });
  return response.json();
};

export const updateVideo = async (videoId, videoData) => {
  const response = await request(`/admin/library_videos/${videoId}`, 'PUT', { library_video: videoData });
  return response.json();
};
